module.exports = __webpack_public_path__ + "14e5ffc77351b389bd4d14826778e15c.svg";